// Game-activity helpers. Canonical implementation lives in
// @streamplace/core; this keeps the historical import path working.
export { getDidFromAtUri, getGameCoverUrl } from "@streamplace/core";
